import logo from '../../../assets/img/colorful.png'

export default function LoginCard({children}) {
    return (
        <div className="relative z-10 w-11/12 mx-auto flex flex-wrap justify-center  bg-white bg-opacity-50 shadow-xl rounded-lg p-5 border-10 border-white ">
            <img className="w-full block mb-8"  style={{ width: "20%" }} src={logo} alt="Transbordadora Austral Broom" />
            {children}
        </div>
    )
}